export default __webpack_public_path__ + "static/19_18-393b2dcdc4309bdcf635d23ea6eea6e5.png";